module.exports = __webpack_public_path__ + "img/208.dirty_urinals.1712a263.svg";